import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "titre" }
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = {
  key: 0,
  class: "icons enregistrement"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  class: "icons enregistrement"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  class: "icon-info",
  id: "icon-info-edtion"
}
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = {
  key: 0,
  class: "custom-tooltip"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "content" }
const _hoisted_17 = {
  class: "widget-container",
  id: "edition-widget-container"
}
const _hoisted_18 = { class: "empty-widget-space" }
const _hoisted_19 = ["aria-label"]
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "container-modale" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_EditionDemandeIntervention = _resolveComponent("EditionDemandeIntervention")!
  const _component_EditionPreventive = _resolveComponent("EditionPreventive")!
  const _component_EditionPreventiveOut = _resolveComponent("EditionPreventiveOut")!
  const _component_EditionEstimate = _resolveComponent("EditionEstimate")!
  const _component_EditionBilling = _resolveComponent("EditionBilling")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ModaleCreationDashboard = _resolveComponent("ModaleCreationDashboard")!
  const _component_ModaleCreationWidget = _resolveComponent("ModaleCreationWidget")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('dashboard.parametrable.edition.titre')), 1),
      _createVNode(_component_ReglePastille, { cle: "editionDashboard.glisserDeposer" }),
      _createVNode(_component_ReglePastille, { cle: "editionDashboard.widgetTaillesDifferentes" }),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.libelleDashboard) = $event)),
        class: "input-libelle",
        maxlength: "45",
        "aria-label": _ctx.$t('dashboard.parametrable.edition.titre')
      }, null, 8, _hoisted_3), [
        [_vModelText, _ctx.libelleDashboard]
      ]),
      _createVNode(_component_ReglePastille, { cle: "editionDashboard.renommageALaSortie" }),
      _createElementVNode("img", {
        src: _ctx.loadIconFavori,
        alt: _ctx.$t("dashboard.parametrable.modale.info.favori"),
        class: "icons cursor-pointer",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.mettreFavori && _ctx.mettreFavori(...args)))
      }, null, 8, _hoisted_4),
      _createVNode(_component_ReglePastille, { cle: "dashboard.favoriIrreversibleIci" }),
      _createElementVNode("img", {
        src: _ctx.loadIconFilter,
        alt: _ctx.$t("dashboard.parametrable.ajout.dashbboard"),
        class: "icons cursor-pointer",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.modaleCreationDashboardOuverte = true)),
        id: "icone-filtre-edition-dashboard"
      }, null, 8, _hoisted_5),
      _createElementVNode("img", {
        src: _ctx.loadIconDelete,
        alt: _ctx.$t("dashboard.parametrable.supprimer"),
        class: "icons cursor-pointer",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.supprimer && _ctx.supprimer(...args)))
      }, null, 8, _hoisted_6),
      _createVNode(_component_ReglePastille, { cle: "dashboard.suppressionFavoriInterdite" }),
      (!_ctx.enregistrementEnCours)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("img", {
              src: _ctx.loadIconCheckVert,
              alt: "",
              "aria-hidden": "true"
            }, null, 8, _hoisted_8),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('dashboard.parametrable.edition.enregistre')), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("img", {
              src: _ctx.loadIconWait,
              alt: "",
              "aria-hidden": "true"
            }, null, 8, _hoisted_10),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('dashboard.parametrable.edition.encours.enregistrement')), 1)
          ])),
      _createVNode(_component_ReglePastille, { cle: "editionDashboard.enregistrementAutomatique" }),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("img", {
          src: _ctx.loadInfoIcon,
          id: "image-info-edition",
          alt: _ctx.$t("dashboard.parametrable.edition.titre"),
          class: "cursor-pointer",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.startOnBoarding && _ctx.startOnBoarding(...args)))
        }, null, 8, _hoisted_12),
        (_ctx.tooltipVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.$t('dashboard.tooltip.edition')), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("button", {
        class: "button-widget",
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.creerWidget && _ctx.creerWidget(...args))),
        id: "bouton-creer-widget"
      }, [
        _createElementVNode("img", {
          src: _ctx.loadIconPlus,
          alt: "",
          "aria-hidden": "true"
        }, null, 8, _hoisted_14),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('dashboard.parametrable.edition.ajouter.widget')), 1)
      ]),
      _createVNode(_component_ReglePastille, { cle: "editionDashboard.widgetFacturationReserve" }),
      _createElementVNode("button", {
        class: "button",
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.goDashboard && _ctx.goDashboard(...args))),
        id: "bouton-quitter-edition-dashboard"
      }, [
        _createElementVNode("img", {
          src: _ctx.loadIconExit,
          alt: "",
          "aria-hidden": "true"
        }, null, 8, _hoisted_15),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('dashboard.parametrable.edition.quitter')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_draggable, {
          list: _ctx.listeWidget,
          class: "draggable",
          onChange: _ctx.changerPosition
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listeWidget, (widget) => {
              return (_openBlock(), _createElementBlock("span", {
                key: widget.id,
                class: _normalizeClass(widget.typeWidgetId === 2 ? "width-65pct" : "width-32pct"),
                id: "edition-widget-span"
              }, [
                (widget.typeWidgetId === 1)
                  ? (_openBlock(), _createBlock(_component_EditionDemandeIntervention, {
                      key: 0,
                      widget: widget,
                      onFiltre: ($event: any) => (_ctx.modifierFiltreWidget(widget)),
                      onDupliquer: ($event: any) => (_ctx.dupliquerWidget(widget)),
                      onSuppression: ($event: any) => (_ctx.supprimerWidget(widget)),
                      class: "third"
                    }, null, 8, ["widget", "onFiltre", "onDupliquer", "onSuppression"]))
                  : _createCommentVNode("", true),
                (widget.typeWidgetId === 2)
                  ? (_openBlock(), _createBlock(_component_EditionPreventive, {
                      key: 1,
                      widget: widget,
                      onFiltre: ($event: any) => (_ctx.modifierFiltreWidget(widget)),
                      onDupliquer: ($event: any) => (_ctx.dupliquerWidget(widget)),
                      onSuppression: ($event: any) => (_ctx.supprimerWidget(widget)),
                      class: "twoThirds"
                    }, null, 8, ["widget", "onFiltre", "onDupliquer", "onSuppression"]))
                  : _createCommentVNode("", true),
                (widget.typeWidgetId === 3)
                  ? (_openBlock(), _createBlock(_component_EditionPreventiveOut, {
                      key: 2,
                      class: "third",
                      widget: widget,
                      onFiltre: ($event: any) => (_ctx.modifierFiltreWidget(widget)),
                      onDupliquer: ($event: any) => (_ctx.dupliquerWidget(widget)),
                      onSuppression: ($event: any) => (_ctx.supprimerWidget(widget))
                    }, null, 8, ["widget", "onFiltre", "onDupliquer", "onSuppression"]))
                  : _createCommentVNode("", true),
                (widget.typeWidgetId === 4)
                  ? (_openBlock(), _createBlock(_component_EditionEstimate, {
                      key: 3,
                      class: "third",
                      widget: widget,
                      onFiltre: ($event: any) => (_ctx.modifierFiltreWidget(widget)),
                      onDupliquer: ($event: any) => (_ctx.dupliquerWidget(widget)),
                      onSuppression: ($event: any) => (_ctx.supprimerWidget(widget))
                    }, null, 8, ["widget", "onFiltre", "onDupliquer", "onSuppression"]))
                  : _createCommentVNode("", true),
                (widget.typeWidgetId === 5)
                  ? (_openBlock(), _createBlock(_component_EditionBilling, {
                      key: 4,
                      class: "third",
                      widget: widget,
                      onFiltre: ($event: any) => (_ctx.modifierFiltreWidget(widget)),
                      onDupliquer: ($event: any) => (_ctx.dupliquerWidget(widget)),
                      onSuppression: ($event: any) => (_ctx.supprimerWidget(widget))
                    }, null, 8, ["widget", "onFiltre", "onDupliquer", "onSuppression"]))
                  : _createCommentVNode("", true)
              ], 2))
            }), 128))
          ]),
          _: 1
        }, 8, ["list", "onChange"]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("button", {
            class: "button-add button-widget",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.creerWidget && _ctx.creerWidget(...args))),
            "aria-label": _ctx.$t('dashboard.parametrable.edition.ajouter.widget')
          }, [
            _createElementVNode("img", {
              src: _ctx.loadIconPlus,
              alt: "",
              "aria-hidden": "true"
            }, null, 8, _hoisted_20)
          ], 8, _hoisted_19)
        ])
      ])
    ]),
    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "height-2pct" }, null, -1)),
    (_ctx.modaleAlerte)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          onCancel: _cache[8] || (_cache[8] = ($event: any) => (_ctx.modaleAlerte = false))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.texteAlerte), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.modaleCreationDashboardOuverte)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 1,
          onCancel: _cache[11] || (_cache[11] = ($event: any) => (_ctx.modaleCreationDashboardOuverte = false))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ModaleCreationDashboard, {
              "is-only-for-site": true,
              onCreationDashboardSuccess: _cache[9] || (_cache[9] = ($event: any) => (_ctx.modaleCreationDashboardOuverte = false)),
              onCancel: _cache[10] || (_cache[10] = ($event: any) => (_ctx.modaleCreationDashboardOuverte = false))
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.modaleWidgetOuverte || _ctx.isModaleForceOpen)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 2,
          onCancel: _cache[13] || (_cache[13] = ($event: any) => (_ctx.modaleWidgetOuverte = false))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ModaleCreationWidget, {
              "widget-a-dupliquer": _ctx.widgetADupliquer,
              "widget-a-modifier": _ctx.widgetAModifier,
              onAjoutWidget: _ctx.ajouterWidget,
              onCancel: _cache[12] || (_cache[12] = ($event: any) => (_ctx.modaleWidgetOuverte = false))
            }, null, 8, ["widget-a-dupliquer", "widget-a-modifier", "onAjoutWidget"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}